import { combineReducers } from 'redux';
import socketUiReducer from './socketUiReducer';
import socketDataReducer from './socketDataReducer';

export default combineReducers({
  ui: socketUiReducer,
  data: socketDataReducer,
});
